import { useParams } from 'react-router-dom';

import { PageWrapper, Paragraph, Section, Subsection, FancyLink } from "./components"

import systems_pages from './doc_systems';
import data_pages from './doc_data';
import dev_pages from './doc_dev';

import Doc from './docs';


const frameworks = {
    dev: {
        title: 'Co-developing Tools and Processes',
        pages: dev_pages,
        descr: 'Building digital tools is only have of the problem. The other half is introducing the processes around them. This framework describes a list of principles for expanding an agile, iterative approach to include evolving scientific processes in parallel to digital tools.',
    },
    data: {
        title: 'Organizing Early Discovery Data',
        pages: data_pages,
        descr: 'Once you\'ve built your data platform, you need to decide how to organize the data inside it. This framework will help you determine the requirements, conventions and processes to ensure data is handled consistently and efficiently.',
    },
    systems: {
        title: 'Designing Data Infrastructure',
        pages: systems_pages,
        descr: 'Whether you\re building a system from scratch or deciding how to improve an existing system, there are multiple angles you can use to break down a system into manageable components. This framework defines three different ways of looking at a data platform.',
    },
}

const FrameworksToC = () => {
    const { frameworkId, pageId } = useParams();

    if (frameworkId) {
        return <Doc
            title={ frameworks[frameworkId].title }
            subtitle='Reference Frameworks'
            pages={ frameworks[frameworkId].pages }
            baseUrl={ `/frameworks/${frameworkId}` }
            pageId={ pageId }
            backToUrl='/frameworks/'
        />
    }

    return <PageWrapper>
        <Section title='Reference Frameworks'>
            <Paragraph>
                This is a collection of resources designed to help readers break down common types of problems into manageable pieces.
            </Paragraph><Paragraph>
                The frameworks don't provide specific steps to solve your problem, but rather give you a starting point for systematically defining a solution that fits your specific situation. The goal of each framework is to answer the question "what am I missing?" by defining a framing for the pieces of a solution, then listing the most common places to look for those pieces.
            </Paragraph><Paragraph>
                 Each framework is based on problems and projects that I've seen while working with early stage drug discovery, and where I've seen teams get overwhelmed with figuring out even where to start. These frameworks can be the place you start.
            </Paragraph>
            { Object.entries(frameworks).map(([id, framework]) =>
                <Subsection
                    to={ framework.pages ? `/frameworks/${id}` : undefined }
                    title={ framework.title }
                >{ framework.descr }</Subsection>
            )}
            <Paragraph>More coming soon...</Paragraph>
            <FancyLink to='/' direction='left'>
                Back to Merelogic Home
            </FancyLink>
        </Section>
    </PageWrapper>
}

export default FrameworksToC;
